import { z } from 'zod';
import { TFunction } from '../_hooks/useAddProductSchema';

const regex =
  /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF\u0020-\u007E\u00A0-\u00FF\u0100-\u024F\u2000-\u206F0-9!@#$%^&*()_+={}[\]:;"'<>,.?/\\|\s-]*$/;

export const getProductInformationSchema = (t: TFunction, tComponents: TFunction) => z.object({
  productName: z.string()
    .trim()
    .min(10, { message: t('minLength', { value: 10 }) })
    .max(50, { message: t('maxLength', { value: 50 }) })
    .regex(regex, { message: tComponents('arabic_english_char_numbers') }),
  description: z.string()
    .trim()
    .min(20, { message: t('minLength', { value: 20 }) })
    .max(1000, { message: t('maxLength', { value: 1000 }) })
    .regex(regex, { message: tComponents('arabic_english_char_numbers') }),
  categoryId: z.string({
    required_error: t('requiredField'),
    invalid_type_error: t('requiredField'),
  }).min(1, { message: t('requiredField') }),
  specialityId: z.string({
    required_error: t('requiredField'),
    invalid_type_error: t('requiredField'),
  }).min(1, { message: t('requiredField') }), //only show when industry is selected
  hsCodeId: z.string({
    required_error: t('requiredField'),
    invalid_type_error: t('requiredField'),
  }).optional().or(z.literal('')), //only show when industry is selected
  productImages: z.array(
    z.object({
      id: z.string(),
      file: z.custom<File>(),
      preview: z.string(),
      uploading: z.boolean().optional(),
    })
  )
    .min(1, { message: t('requiredField') })
    .max(10, { message: t('maxItems', { value: 10 }) })
    .refine(
      (images) => !images.some((img) => img.uploading),
      { message: t('uploadInProgress') }
    ),
  locationId: z.string().optional(),
});

